export const awsRoute53Paths = {
  zones: (connectionId) => `/compute/cloud-account-connections/${connectionId}/aws/dns/zones`,
  healthChecks: (connectionId) => `/compute/cloud-account-connections/${connectionId}/aws/dns/health-checks`,
  zoneDetail: (connectionId, hostedZoneId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/dns/zones/${encodeURIComponent(hostedZoneId)}`,
  healthCheckDetail: (connectionId, healthCheckId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/dns/health-checks/${encodeURIComponent(healthCheckId)}`,
  deleteHealthCheck: (connectionId, healthCheckId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/dns/health-checks/${encodeURIComponent(healthCheckId)}`,
  recordSets: (connectionId, hostedZoneId) =>
    `/compute/cloud-account-connections/${connectionId}/aws/dns/zones/${encodeURIComponent(hostedZoneId)}/records`,
  deleteRecordSet: (connectionId, hostedZoneId, params) => {
    const search = new URLSearchParams();
    if (params?.name) search.set('name', params.name);
    if (params?.type) search.set('type', params.type);
    if (params?.ttl !== undefined && params?.ttl !== null && params?.ttl !== '') search.set('ttl', String(params.ttl));
    if (params?.values) search.set('values', params.values);
    if (params?.aliasDnsName) search.set('aliasDnsName', params.aliasDnsName);
    if (params?.aliasHostedZoneId) search.set('aliasHostedZoneId', params.aliasHostedZoneId);
    if (params?.evaluateTargetHealth !== undefined && params?.evaluateTargetHealth !== null) {
      search.set('evaluateTargetHealth', String(Boolean(params.evaluateTargetHealth)));
    }
    if (params?.setIdentifier) search.set('setIdentifier', params.setIdentifier);
    if (params?.weight !== undefined && params?.weight !== null && params?.weight !== '') search.set('weight', String(params.weight));
    if (params?.region) search.set('region', params.region);
    if (params?.failover) search.set('failover', params.failover);
    if (params?.multiValueAnswer !== undefined && params?.multiValueAnswer !== null) {
      search.set('multiValueAnswer', String(Boolean(params.multiValueAnswer)));
    }
    if (params?.healthCheckId) search.set('healthCheckId', params.healthCheckId);
    const query = search.toString();
    return `${awsRoute53Paths.recordSets(connectionId, hostedZoneId)}${query ? `?${query}` : ''}`;
  },
};
